export default __webpack_public_path__ + "static/media/2492.0dccb70d.png";